import React from 'react';

// Note: This is being used from the GWT side in order to inject react components
// The componentName corresponds to ReactComponentName enum entries in ondemand repo (+ a few others)
// Should be removed when GWT is gone.
export const getLazyReactComponent = componentName => {
  const Component = {};
  switch (componentName) {
    case 'ReactRoot':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "ReactRoot" */ 'pages/ReactRoot'),
      };
      Component.importPath = require.resolveWeak('pages/ReactRoot');
      break;
    case 'Passwords':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "Passwords" */ 'pages/Passwords'),
      };
      Component.importPath = require.resolveWeak('pages/Passwords');
      break;
    case 'TrialRegistration':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "TrialRegistration" */ 'pages/TrialRegistration'
          ),
      };
      Component.importPath = require.resolveWeak('pages/TrialRegistration');
      break;
    case 'OAuthCode':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "OAuthCode" */ 'pages/OAuthCode'),
      };
      Component.importPath = require.resolveWeak('pages/OAuthCode');
      break;
    case 'OAuthProxyRedirect':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "OAuthProxyRedirect" */ 'pages/OAuthProxyRedirect'
          ),
      };
      Component.importPath = require.resolveWeak('pages/OAuthProxyRedirect');
      break;
    case 'IntegrationManager':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "IntegrationManager" */ 'pages/IntegrationManager'
          ),
      };
      Component.importPath = require.resolveWeak('pages/IntegrationManager');
      break;
    case 'IntegrationBuilder':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "IntegrationBuilder" */ 'pages/IntegrationBuilder'
          ),
      };
      Component.importPath = require.resolveWeak('pages/IntegrationBuilder');
      break;
    case 'WhosOnDutyGroupSelection':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "WhosOnDuty" */ 'pages/WhosOnDuty'),
      };
      Component.importPath = require.resolveWeak('pages/WhosOnDuty');
      break;
    case 'TimelineReport':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "TimelineReport" */ 'pages/Reports/TimelineReport'
          ),
      };
      Component.importPath = require.resolveWeak(
        'pages/Reports/TimelineReport',
      );
      break;
    case 'InstallDeviceDialog':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "InstallDeviceDialog" */ 'pages/InstallDeviceDialog'
          ),
      };
      Component.importPath = require.resolveWeak(
        'pages/InstallDeviceDialog/InstallDeviceDialog',
      );
      break;
    // Remove InstallMobileApp case once GWT is deployed to prod using InstallDeviceDialog instead:
    case 'InstallMobileApp':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "InstallMobileApp" */ 'pages/InstallDeviceDialog/InstallMobileApp'
          ),
      };
      Component.importPath = require.resolveWeak(
        'pages/InstallDeviceDialog/InstallMobileApp',
      );
      break;
    case 'XAgentManager':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "XAgentManager" */ 'pages/XAgentManager'),
      };
      Component.importPath = require.resolveWeak('pages/XAgentManager');
      break;
    case 'RecipientSearch':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "RecipientSearch" */ 'pages/RecipientSearch'
          ),
      };
      Component.importPath = require.resolveWeak('pages/RecipientSearch');
      break;
    case 'RecipientMultiSelect':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GwtMessagingRecipientsMultiSelect" */ 'pages/Messaging/components/GwtMessagingRecipientsMultiSelect'
          ),
      };
      Component.importPath = require.resolveWeak(
        'pages/Messaging/components/GwtMessagingRecipientsMultiSelect',
      );
      break;
    case 'AddShift':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "AddShift" */ 'pages/AddShift'),
      };
      Component.importPath = require.resolveWeak('pages/AddShift');
      break;
    case 'EditShift':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "EditShift" */ 'pages/EditShift'),
      };
      Component.importPath = require.resolveWeak('pages/EditShift');
      break;
    case 'UserInfoDetails':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "UserInfoDetails" */ 'pages/UserInfoDetails'
          ),
      };
      Component.importPath = require.resolveWeak('pages/UserInfoDetails');
      break;
    case 'ConferenceEventsModal':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "ConferencesReport_ConferenceEventsModal" */ 'pages/Reports/ConferencesReport/ConferenceEventsModal'
          ),
      };
      Component.importPath = require.resolveWeak(
        'pages/Reports/ConferencesReport/ConferenceEventsModal',
      );
      break;
    case 'SpeakingList':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "SpeakingList" */ 'pages/SpeakingList'),
      };
      Component.importPath = require.resolveWeak('pages/SpeakingList');
      break;
    case 'Alerts':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "Alerts" */ 'pages/Reports/Alerts'),
      };
      Component.importPath = require.resolveWeak('pages/Reports/Alerts');
      break;
    case 'EventDetailsReport':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "EventDetailsReport" */ 'pages/Reports/EventDetailsReport'
          ),
      };
      Component.importPath = require.resolveWeak(
        'pages/Reports/EventDetailsReport',
      );
      break;
    case 'ImportJobDetailsReport':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "ImportJobDetailsReport" */ 'pages/Reports/ImportJobDetailsReport'
          ),
      };
      Component.importPath = require.resolveWeak(
        'pages/Reports/ImportJobDetailsReport',
      );
      break;
    case 'ImportJobHistoryReport':
      Component.dynamic = {
        // eslint-disable-next-line react/display-name
        loading: () => <div />, // skip page level spinner
        loader: () =>
          import(
            /* webpackChunkName: "ImportJobHistoryReport" */ 'pages/Reports/ImportJobHistoryReport'
          ),
      };
      Component.importPath = require.resolveWeak(
        'pages/Reports/ImportJobHistoryReport',
      );
      break;
    case 'ImportJobUpload':
      Component.dynamic = {
        // eslint-disable-next-line react/display-name
        loading: () => <div />, // skip page level spinner
        loader: () =>
          import(
            /* webpackChunkName: "ImportJobUpload" */ 'pages/Reports/ImportJobUpload'
          ),
      };
      Component.importPath = require.resolveWeak(
        'pages/Reports/ImportJobUpload',
      );
      break;
    case 'FloodControl':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "FloodControl" */ 'pages/FloodControl'),
      };
      Component.importPath = require.resolveWeak('pages/FloodControl');
      break;
    case 'UserLimitAlertBox':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "UserLimitAlert" */ 'pages/InviteUsers/AlertBox'
          ),
      };
      Component.importPath = require.resolveWeak('pages/InviteUsers/AlertBox');
      break;
    case 'ForTeamsAlert':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "ForTeamsAlert" */ 'pages/ForTeamsAlert'),
      };
      Component.importPath = require.resolveWeak('pages/ForTeamsAlert');
      break;
    case 'PremiumVoiceAlert':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "PremiumVoiceAlert" */ 'pages/PremiumVoiceAlert'
          ),
      };
      Component.importPath = require.resolveWeak('pages/PremiumVoiceAlert');
      break;
    case 'SimpleAlert':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "SimpleAlert" */ 'pages/SimpleAlert'),
      };
      Component.importPath = require.resolveWeak('pages/SimpleAlert');
      break;
    case 'DSTAlert':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "DSTAlert" */ 'pages/DSTAlert'),
      };
      Component.importPath = require.resolveWeak('pages/DSTAlert');
      break;
    case 'DevicesEmptyState':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "DevicesEmptyState" */ 'pages/Devices/containers/AddDevicesWrapper'
          ),
      };
      Component.importPath = require.resolveWeak(
        'pages/Devices/containers/AddDevicesWrapper',
      );
      break;
    case 'AddAbsence':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "AddAbsence" */ 'pages/TemporaryAbsence/AddAbsence'
          ),
      };
      Component.importPath = require.resolveWeak(
        'pages/TemporaryAbsence/AddAbsence',
      );
      break;
    case 'DeviceValidationDropdown':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "DeviceValidationDropdown" */ 'pages/Devices/components/DeviceValidationDropdown'
          ),
      };
      Component.importPath = require.resolveWeak(
        'pages/Devices/components/DeviceValidationDropdown',
      );
      break;
    case 'UpcomingAbsences':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "UpcomingAbsences" */ 'pages/TemporaryAbsence/UpcomingAbsences'
          ),
      };
      Component.importPath = require.resolveWeak(
        'pages/TemporaryAbsence/UpcomingAbsences',
      );
      break;
    case 'SuppressedEventsList':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "SuppressedEventsList" */ 'pages/SuppressedEventsList'
          ),
      };
      Component.importPath = require.resolveWeak('pages/SuppressedEventsList');
      break;
    case 'AbsentBadge':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "AbsentBadge" */ 'components/AbsentBadge'
          ),
      };
      Component.importPath = require.resolveWeak('components/AbsentBadge');
      break;
    case 'WorkflowFormsEmptyState':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "WorkflowFormsEmptyState" */ 'components/WorkflowFormsEmptyState'
          ),
      };
      Component.importPath = require.resolveWeak(
        'components/WorkflowFormsEmptyState',
      );
      break;
    case 'DeleteFormButton':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "DeleteFormButton" */ 'components/DeleteFormButton'
          ),
      };
      Component.importPath = require.resolveWeak('components/DeleteFormButton');
      break;
    case 'FlowDesigner':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "FlowDesigner" */ 'pages/FlowDesigner'),
      };
      Component.importPath = require.resolveWeak('pages/FlowDesigner');
      break;
    case 'WorkflowHeader':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "WorkflowUiHeader" */ 'pages/WorkflowHeader'
          ),
      };
      break;
    case 'GwtMessagingPropertyList':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GwtMessagingPropertyList" */ 'pages/Messaging/components/GwtMessagingPropertyList'
          ),
      };
      break;
    case 'WorkflowImportButton':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "WorkflowImportButton" */ 'components/WorkflowImportButton'
          ),
      };
      break;
    case 'GwtMessagingPropertyComboBox':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GwtMessagingPropertyComboBox" */ 'pages/Messaging/components/GwtMessagingPropertyComboBox'
          ),
      };
      break;
    case 'GwtMessagingPropertyServices':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GwtMessagingPropertyServices" */ 'pages/Messaging/components/GwtMessagingPropertyServices'
          ),
      };
      break;
    case 'UserAPIKeys':
      Component.dynamic = {
        loader: () =>
          import(/* webpackChunkName: "UserAPIKeys" */ 'pages/UserAPIKeys'),
      };
      break;
    case 'EventTrafficWidget':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "EventTrafficWidget" */ 'pages/EventTrafficWidget'
          ),
      };
      break;
    case 'EventTrafficWidgetSettings':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "EventTrafficWidgetSettings" */ 'pages/EventTrafficWidget/Settings'
          ),
      };
      break;
    case 'GroupPerformanceWidget':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GroupPerformanceWidget" */ 'pages/GroupPerformanceWidget'
          ),
      };
      break;
    case 'GroupPerformanceWidgetSettings':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GroupPerformanceWidgetSettings" */ 'pages/GroupPerformanceWidget/Settings'
          ),
      };
      break;
    case 'GroupPerformance':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GroupPerformance" */ 'pages/Reports/GroupPerformanceReport'
          ),
      };
      break;
    case 'PerformanceReportContainer':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "PerformanceReportContainer" */ 'pages/Reports/PerformanceReports/PerformanceReportContainer'
          ),
      };
      break;
    case 'IncidentSeverityWidget':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "IncidentActivityWidget" */ 'pages/IncidentActivityWidget'
          ),
      };
      break;
    case 'IncidentSeverityWidgetSettings':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "IncidentActivityWidgetSettings" */ 'pages/IncidentActivityWidget/Settings'
          ),
      };
      break;
    case 'DashboardAlertsWidgetRetentionAlert':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "DashboardLinksWidgetSettings" */ 'pages/Dashboard/AlertsWidget/RetentionAlert'
          ),
      };
      break;
    case 'DashboardLinksWidget':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "DashboardLinksWidget" */ 'pages/Dashboard/DashboardLinksWidget'
          ),
      };
      break;
    case 'DashboardLinksWidgetSettings':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "DashboardLinksWidgetSettings" */ 'pages/Dashboard/DashboardLinksWidget/Settings'
          ),
      };
      break;
    case 'IncidentSettings':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "IncidentSettings" */ 'pages/IncidentManagement/IncidentSettings'
          ),
      };
      break;
    case 'IncidentTypeProperties':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "IncidentTypeProperties" */ 'pages/IncidentManagement/IncidentTypeProperties'
          ),
      };
      break;
    case 'GwtReactIncidentDialog':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GwtReactIncidentDialog" */ 'pages/IncidentManagement/ViewIncidents/InitIncident/GwtReactIncidentDialog'
          ),
      };
      break;
    case 'FlowFormSubmission':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "FlowFormSubmission" */ 'pages/FlowFormSubmission'
          ),
      };
      break;
    case 'FormTriggerTypeAlert':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "FormTriggerTypeAlert" */ 'pages/FormTriggerType/FormTriggerTypeAlert'
          ),
      };
      break;
    case 'FormTriggerTypePill':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "FormTriggerTypePill" */ 'pages/FormTriggerType/FormTriggerTypePill'
          ),
      };
      break;
    case 'GWTEditConstantsButton':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GWTEditConstantsButton" */ 'pages/WorkflowComponents/GWTEditConstantsButton'
          ),
      };
      break;
    case 'GWTEditEndpointsButton':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GWTEditEndpointsButton" */ 'pages/WorkflowComponents/GWTEditEndpointsButton'
          ),
      };
      break;
    case 'GWTEditEmailTemplateButton':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GWTEditEmailTemplateButton" */ 'pages/WorkflowComponents/GWTEditTemplateButton/GWTEditEmailTemplateButton'
          ),
      };
      break;
    case 'GWTEditSmsTemplateButton':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GWTEditSmsTemplateButton" */ 'pages/WorkflowComponents/GWTEditTemplateButton/GWTEditSmsTemplateButton'
          ),
      };
      break;
    case 'HomePagePlace-SendMessages':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "HomePagePlace-SendMessages" */ 'pages/HomePagePlace/SendMessages'
          ),
      };
      break;
    case 'GroupOverviewServices':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GroupOverviewServices" */ 'pages/GroupDetails/Services'
          ),
      };
      break;
    case 'GwtCodeEditor':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GwtCodeEditor" */ 'pages/GwtPages/CodeEditor'
          ),
      };
      break;
    case 'StakeholderBadge':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "StakeholderBadge" */ 'components/StakeholderBadge'
          ),
      };
      break;
    case 'CompanyLicenseDetails':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "CompanyLicenseDetails" */ 'pages/GeneralSettings/components/CompanyLicenseDetails'
          ),
      };
      break;
    // Allow either BroadcastNotifyMembersList or GroupNotifyMembersList naming for slower,
    // non-breaking transition on Ondemand side:
    case 'BroadcastNotifyMembersList':
    case 'GroupNotifyMembersList':
      Component.dynamic = {
        loader: () =>
          import(
            /* webpackChunkName: "GroupNotifyMembersList" */ 'components/GroupNotifyMembersList'
          ),
      };
      break;
    default:
      // eslint-disable-next-line no-console
      console.error(
        `Missing component for component name '${componentName}'! This probably means you forgot to add it to getLazyReactComponent`,
      );
      break;
  }

  return Component;
};
